<template>
    <div class="order-form-component">

        <!-- Introduction -->
        <div class="introduction">
            <div class="row">
                <div class="col-12">
                    <h3>{{ sectionOneHeading }}</h3>
                    <div v-html="description"></div>
                </div>
            </div>
        </div>

        <div class="your-details" v-if="session">
            <driver-profile :driver-grade="driverGrade" :profile="driverProfile" :session="session" :declaration="declaration"></driver-profile>
        </div>


    </div>
</template>

<script>
import {EventBus} from '@/event-bus.js';
import DriverProfile from "../driver-profile";
import VehicleCard from "../../vehicle-details/vehicle-card";

export default {
    components: {VehicleCard, DriverProfile},

    beforeRouteLeave(to, from, next) {
        if (to.name === 'Login') {
            next();
        }

        if (to.name === 'ECO / AMAPS Product Details') {
            document.getElementById('order-process-wrap').scrollTo({top: 0, behavior: 'smooth'});

            if ( !this.confirmations.employeeDetails ) {
                EventBus.$emit('showError', true);
                EventBus.$emit('errorTitle', 'Please confirm all points to continue');
                EventBus.$emit('errorMessage', '');
                return false;
            }
        }

        next();
    },

    props: [
        'session',
        'driverGrade',
        'driverProfile',
        'confirmations',
        'adminPortalData',
        'sectionOneHeading',
    ],

    watch: {
        confirmations: {
            handler(confirmations) {
              EventBus.$emit('setConfirmations', confirmations);
            },
            deep: true
        }
    },

    computed: {
        description() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_one_section_one_description : '';
        },
        declaration() {
            return this.adminPortalData.content ? this.adminPortalData.content.products.ecoamaps[0].order_stage_one_declaration_text : '';
        },
    }
}
</script>
